export const BRIDGE_PROTOCOL = {
  CHANNEL: "venue.pm",
  VERSION: "1.0",
} as const

// How long the parent waits for the child's bridge:ack before treating the
// connection as failed.
export const BRIDGE_READY_TIMEOUT_MS = 20_000

export const BRIDGE_PARENT_EVENTS = {
  // handshake
  SYNC_ACK: "bridge:sync-ack",

  // navigation (parent -> child)
  NAV_NAVIGATION_ENDED: "nav:navigationEnded",

  // Ui (parent -> child)
  UI_CHANGE_LANGUAGE: "ui:changeLanguage",

  // App (parent → child)
  /**
   * Requests the child app to cancel an ongoing process (gracefully).
   * The child should handle this command if it supports cancellable tasks.
   */
  APP_CANCEL_PROCESS: "app:cancelProcess",

  // error
  ERROR: "error",
} as const

export const BRIDGE_CHILD_EVENTS = {
  // handshake
  SYNC: "bridge:sync",
  ACK: "bridge:ack",
  DISCONNECT: "bridge:disconnect",

  // navigation (child -> parent)
  NAV_OPEN_SEARCH: "nav:openSearch",
  NAV_OPEN_PLACE: "nav:openPlace",
  NAV_OPEN_SERVICES: "nav:openServices",
  NAV_OPEN_EVENTS: "nav:openEvents",
  NAV_OPEN_EVENT_DETAIL: "nav:openEventDetail",
  NAV_OPEN_PROMOTIONS: "nav:openPromotions",
  NAV_OPEN_PROMOTION_DETAIL: "nav:openPromotionDetail",
  NAV_OPEN_DIRECTORY: "nav:openDirectory",
  NAV_SHOW_DIRECTIONS: "nav:showDirections",
  NAV_START_NAVIGATION: "nav:startNavigation",
  NAV_NEXT_STEP_NAVIGATION: "nav:nextStep",
  NAV_PREV_STEP_NAVIGATION: "nav:previousStep",

  // error
  ERROR: "error",
} as const

export const BRIDGE_EVENTS = {
  ...BRIDGE_PARENT_EVENTS,
  ...BRIDGE_CHILD_EVENTS,
} as const
